import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import * as React from 'react';
import styled from 'styled-components';
import { breakpoint, color, borderRadius, shadow } from '@core-ds/primitives';
import Label from './label.js';
import { Plus as PlusIcon } from '@core-ds/icons/16';
import { _js } from '@ifixit/localize';
var ABOVE_MOBILE = "@media screen and (min-width: ".concat(breakpoint.md, ")");
var blockPadding = 10;
var thisItemMargin = 5;
var imageWidth = '160px';
var Grid = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   display: flex;\n   flex-direction: row;\n   justify-content: center;\n   align-items: center;\n"])));
var Block = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   position: relative;\n   padding: ", "px 0;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   flex-basis: ", ";\n"])), blockPadding, imageWidth);
var ThisItem = styled(Label)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   display: none;\n   ", " {\n      display: block;\n   }\n   position: absolute;\n   top: ", "px;\n   right: ", "px;\n"])), ABOVE_MOBILE, blockPadding + thisItemMargin, thisItemMargin);
var Image = styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   width: 100%;\n   transition: opacity ease 0.5s;\n   opacity: ", ";\n   border-radius: ", ";\n   box-shadow: ", ";\n"])), function (props) {
  return props.isSelected ? '1' : '0.5';
}, borderRadius.md, shadow[1]);
var Plus = styled(PlusIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n   flex-shrink: 0;\n   color: ", ";\n   margin: 20px 2.5%;\n"])), color.gray[500]);

function ProductImage(_ref) {
  var product = _ref.product,
      isSelected = _ref.isSelected;
  var image = /*#__PURE__*/React.createElement(Image, {
    isSelected: isSelected,
    src: product.image,
    alt: product.title
  });
  return product.link ? /*#__PURE__*/React.createElement("a", {
    href: product.link
  }, image) : image;
}

function ProductImageGrid(_ref2) {
  var initialProduct = _ref2.initialProduct,
      relatedProducts = _ref2.relatedProducts,
      isSelected = _ref2.isSelected;
  return /*#__PURE__*/React.createElement(Grid, null, relatedProducts.map(function (product, key) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, product.sku !== initialProduct.sku && /*#__PURE__*/React.createElement(Plus, null), /*#__PURE__*/React.createElement(Block, null, product.sku === initialProduct.sku && /*#__PURE__*/React.createElement(ThisItem, null, _js('This Item')), /*#__PURE__*/React.createElement(ProductImage, {
      isSelected: isSelected(product),
      product: product
    })));
  }));
}

export default ProductImageGrid;